import { Icon, Link, Tooltip, TooltipContent } from '@customerio/pluma-components/react';

/**
 * The marker on an attribute Customer.io writes rather than the customer:
 * the immutable id, the timestamp it stamps on a new person, and the values
 * it derives from an IP address.
 */

const CIO_ID_DOCS = 'https://docs.customer.io/identifying-people/#cio_id';

type AutogeneratedAttributeTooltipProps = {
  attribute: string;
};

export function AutogeneratedAttributeTooltip({ attribute }: AutogeneratedAttributeTooltipProps) {
  const isCioId = attribute === 'cio_id';

  return (
    <Tooltip isCustom>
      {(context) => (
        <>
          <Icon
            name="help"
            size="sm"
            color="subtle"
            cursor="help"
            flexShrink="0"
            ref={context.reference.setReference}
            {...context.reference.getReferenceProps()}
          />
          <TooltipContent>
            {isCioId ? (
              <>
                We automatically generate this value as our own database key.
                <br />
                <Link href={CIO_ID_DOCS} color="inherit" isUnderlined isExternal>
                  Learn more
                </Link>
              </>
            ) : (
              'Auto-generated by Customer.io'
            )}
          </TooltipContent>
        </>
      )}
    </Tooltip>
  );
}
